import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WcGridModule } from '../../components/wc-grid/wc-grid.module';
import { HttpService } from '../../utility/http-service';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { FoldingEditorComponent } from './folding-editor/folding-editor.component';
import { MappingEditorComponent } from './mapping-editor/mapping-editor.component';

@Component({
  selector: 'app-client-dataset-editor',
  standalone: true,
  templateUrl: './client-dataset-editor.component.html',
  styleUrls: ['./client-dataset-editor.component.css'],
  imports: [CommonModule, WcGridModule, MatDialogModule],
})
export class ClientDatasetEditorComponent implements OnChanges {
  @Input() clientId!: string;

  /** Passed as [context] to wc-grid so every data + bulkOps request carries the clientId. */
  gridContext: Record<string, any> = {};

  readonly rowActions = [
    { id: 'exportFields', label: 'Export Field Definitions' },
    { id: 'exportMapping', label: 'Export Mapping' },
    { id: 'runSync', label: 'Run Sync' },
    { id: 'editFolding', label: 'Edit Folding Config' },
    { id: 'editMapping', label: 'Edit Mappings' },
  ];

  constructor(private http: HttpService, private dialog: MatDialog) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['clientId'] && this.clientId) {
      this.gridContext = { clientId: this.clientId };
    }
  }

  onRowAction(event: { id: string; row: Record<string, any> }): void {
    switch (event.id) {
      case 'exportFields':
        this.http.getFile(`ClientDataModel/ExportFields?dataSetId=${event.row['Id']}`);
        break;
      case 'exportMapping':
        this.http.getFile(`ClientDataModel/ExportMapping?dataSetId=${event.row['Id']}`);
        break;
      case 'runSync':
        this.http.post(`ClientDataModel/RunSync?dataSetId=${event.row['Id']}`, () => {});
        break;
      case 'editFolding':
        this.dialog.open(FoldingEditorComponent, {
          data: { dataSetId: event.row['Id'], dataSetName: event.row['Name'] },
          minWidth: '520px',
        });
        break;
      case 'editMapping':
        this.dialog.open(MappingEditorComponent, {
          data: {
            dataSetId: event.row['Id'],
            dataSetName: event.row['Name'],
            externalDataModel: event.row['ExternalDataModel']
          },
          minWidth: '700px',
        });
        break;
    }
  }

  private downloadFile(endpoint: string): void {
    this.http.getFile(endpoint);
  }
}
